const { parse: C, stringify: w } = JSON, { keys: D } = Object, u = String, P = "string", m = {}, y = "object", S = (t, e) => e, v = (t) => t instanceof u ? u(t) : t, _ = (t, e) => typeof e === P ? new u(e) : e, M = (t, e, o, r) => {
  const a = [];
  for (let n = D(o), { length: d } = n, l = 0; l < d; l++) {
    const i = n[l], p = o[i];
    if (p instanceof u) {
      const c = t[p];
      typeof c === y && !e.has(c) ? (e.add(c), o[i] = m, a.push({ k: i, a: [t, e, c, r] })) : o[i] = r.call(o, i, c);
    } else
      o[i] !== m && (o[i] = r.call(o, i, p));
  }
  for (let { length: n } = a, d = 0; d < n; d++) {
    const { k: l, a: i } = a[d];
    o[l] = r.call(o, l, M.apply(null, i));
  }
  return o;
}, g = (t, e, o) => {
  const r = u(e.push(o) - 1);
  return t.set(o, r), r;
}, E = (t, e) => {
  const o = C(t, _).map(v), r = o[0], a = e || S, n = typeof r === y && r ? M(o, /* @__PURE__ */ new Set(), r, a) : r;
  return a.call({ "": n }, "", n);
}, G = (t, e, o) => {
  const r = e && typeof e === y ? (c, f) => c === "" || -1 < e.indexOf(c) ? f : void 0 : e || S, a = /* @__PURE__ */ new Map(), n = [], d = [];
  let l = +g(a, n, r.call({ "": t }, "", t)), i = !l;
  for (; l < n.length; )
    i = !0, d[l] = w(n[l++], p, o);
  return "[" + d.join(",") + "]";
  function p(c, f) {
    if (i)
      return i = !i, f;
    const h = r.call(this, c, f);
    switch (typeof h) {
      case y:
        if (h === null)
          return h;
      case P:
        return a.get(h) || g(a, n, h);
    }
    return h;
  }
}, A = (t) => C(G(t)), I = (t) => E(w(t)), s = function(t) {
  var e = this;
  this.$iframe = t, this.player = t.contentWindow, this.onMessage = this.onMessage.bind(this), this._startup = {
    loading: "pending",
    loaderError: null,
    done: !1
  }, this.loaded = new Promise(function(o, r) {
    e._startup.resolve = o, e._startup.reject = r;
  }), this.listeners = {}, window.addEventListener("message", this.onMessage), this.sendCommand("broadcastLoadedState");
};
s.prototype.on = function(t, e) {
  this.listeners[t] || (this.listeners[t] = []), this.listeners[t].indexOf(e) === -1 && this.listeners[t].push(e);
};
s.prototype.off = function(t, e) {
  let o;
  this.listeners[t] && (o = this.listeners[t].indexOf(e), o >= -1 && this.listeners[t].splice(o, 1));
};
s.prototype.trigger = function(t) {
  this.listeners[t.type] && this.listeners[t.type].forEach((e) => e(t));
};
s.prototype.onLoaderStateChanged = function(t) {
  t.state.isLoading || (t.state.isLoaded ? this._startup.loading = "fulfilled" : (this._startup.loading = "rejected", this._startup.loaderError = t.state.error), this.sendCommand("broadcastPlayerState"));
};
s.prototype.onPlayerStateChanged = function(t) {
  if (this._startup.done)
    this.trigger(t);
  else
    switch (this._startup.loading) {
      case "fulfilled":
        this._startup.done = !0, this._startup.resolve({
          playerApi: this,
          playerState: t.state
        });
        break;
      case "rejected":
        this._startup.done = !0, this._startup.reject({
          loaderError: this._startup.loaderError,
          playerState: t.state
        });
        break;
    }
};
s.prototype.onMessage = function(t) {
  let e;
  if (t.source === this.$iframe.contentWindow && !(!t.data || typeof t.data != "object" || t.data.type !== "RADIANT_EMBED_EVENT"))
    try {
      e = I(t.data.event), this.handleEvent(e);
    } catch (o) {
      console.log(o);
      return;
    }
};
s.prototype.handleEvent = function(t) {
  switch (t.type) {
    case "loaderStateChanged":
      return this.onLoaderStateChanged(t);
    case "playerStateChanged":
      return this.onPlayerStateChanged(t);
    case "autoplayMode":
      return this.resolveGetAutoplayModePromise(t.autoplayMode);
    case "cursor":
      return this.resolveGetCursorPromise(t.cursor);
    case "duration":
      return this.resolveGetDurationPromise(t.duration);
    case "isShowingControls":
      return this.resolveIsShowingControlsPromise(
        t.isShowingControls
      );
    case "destroyed":
      return this.resolveDestroyPromise();
    case "adblock":
    case "autoplayModeDetected":
    case "cursorChanged":
    case "durationChanged":
    case "enterPictureInPicture":
    case "fatalError":
    case "leavePictureInPicture":
    case "loadedMetadata":
    case "playerError":
    case "playerInView":
    case "playerOutOfView":
    case "setupError":
      return this.trigger(t);
    default:
      return;
  }
};
s.prototype.resolveGetAutoplayModePromise = function(t) {
  this.resolveGetAutoplayMode && (this.resolveGetAutoplayMode(t), delete this.resolveGetAutoplayMode);
};
s.prototype.resolveGetCursorPromise = function(t) {
  this.resolveGetCursor && (this.resolveGetCursor(t), delete this.resolveGetCursor);
};
s.prototype.resolveGetDurationPromise = function(t) {
  this.resolveGetDuration && (this.resolveGetDuration(t), delete this.resolveGetDuration);
};
s.prototype.resolveIsShowingControlsPromise = function(t) {
  this.resolveIsShowingControls && (this.resolveIsShowingControls(t), delete this.resolveIsShowingControls);
};
s.prototype.resolveDestroyPromise = function() {
  this.resolveDestroy && (this.resolveDestroy(), delete this.resolveDestroy);
};
s.prototype.sendCommand = function(t, e) {
  this.player.postMessage(
    {
      type: "RADIANT_EMBED_COMMAND",
      command: t,
      args: A(e)
    },
    "*"
  );
};
s.prototype.changeMedia = function(t, e, o, r, a, n) {
  this.sendCommand("changeMedia", [
    t,
    e,
    o,
    r,
    a,
    n
  ]);
};
s.prototype.destroy = function() {
  let t = this;
  return new Promise(function(e) {
    t.resolveDestroy = e, t.sendCommand("destroy");
  });
};
s.prototype.getAutoplayMode = function() {
  let t = this;
  return new Promise(function(e) {
    t.resolveGetAutoplayMode = e, t.sendCommand("getAutoplayMode");
  });
};
s.prototype.getCursor = function() {
  let t = this;
  return new Promise(function(e) {
    t.resolveGetCursor = e, t.sendCommand("getCursor");
  });
};
s.prototype.getDuration = function() {
  let t = this;
  return new Promise(function(e) {
    t.resolveGetDuration = e, t.sendCommand("getDuration");
  });
};
s.prototype.hideControls = function() {
  this.sendCommand("hideControls");
};
s.prototype.isShowingControls = function() {
  let t = this;
  return new Promise(function(e) {
    t.resolveIsShowingControls = e, t.sendCommand("isShowingControls");
  });
};
s.prototype.pause = function() {
  this.sendCommand("pause");
};
s.prototype.play = function() {
  this.sendCommand("play");
};
s.prototype.requestReinitializeVolume = function() {
  this.sendCommand("requestReinitializeVolume");
};
s.prototype.seek = function(t) {
  this.sendCommand("seek", [t]);
};
s.prototype.setPlayerSize = function(t, e, o, r, a, n) {
  this.sendCommand("setPlayerSize", [
    t,
    e,
    o,
    r,
    a,
    n
  ]);
};
s.prototype.setup = function(t) {
  this.sendCommand("setup", [t]);
};
s.prototype.showControls = function() {
  this.sendCommand("showControls");
};
s.prototype.stop = function() {
  this.sendCommand("stop");
};
export {
  s as default
};
//# sourceMappingURL=IframePlayerApi.mjs.map
